import React, { Component } from 'react';
import ErrorPage from './../../components/ErrorPage';
import { auth } from './../../config/Fire';

class ErrorPageContainer extends Component {

    componentDidMount() {
        auth.signOut();
    }
    
    render() {
        return (
            <div>
                <ErrorPage />
            </div>
        );
    }
}

ErrorPageContainer.propTypes = {

};

export default ErrorPageContainer;